import { getVisibleArrows } from '../../../core/components/axes/components/PanningControls/get-visible-arrows.js';
import { PanningControls } from '../../../core/components/axes/components/PanningControls/PanningControls.js';
import { useCurrentDomainState } from '../../hooks/store/selectors.js';
import { useInfiniteZoomConfig } from '../../hooks/useInfiniteZoomConfig.js';
import { useMinMaxXAxis } from '../../hooks/useMinMaxXAxis.js';
import { useTimeseriesZoomRanges } from '../../hooks/useTimeseriesZoomRanges.js';

interface TimeseriesPanningControlsProps {
  onClickPan: (domain: number) => void;
}

export const TimeseriesPanningControls = (
  props: TimeseriesPanningControlsProps,
) => {
  const { onClickPan } = props;

  const { min, max } = useMinMaxXAxis();
  const { initialZoom } = useTimeseriesZoomRanges();
  const currentDomain = useCurrentDomainState();
  const infiniteZoom = useInfiniteZoomConfig();

  const { left, right } = getVisibleArrows(
    { min, max },
    initialZoom,
    currentDomain,
    infiniteZoom,
  );

  return (
    <PanningControls
      onClickPan={onClickPan}
      showLeftControl={left}
      showRightControl={right}
    />
  );
};
